export var HEADING_TYPES = Object.freeze({
  0: 'h0',
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5',
  6: 'h6'
});